export enum Page {
  HOME = '/',
  LOGIN = '/login',
  ENABLEMENT = '/enablement',
  INVENTORY = '/inventory',
  INVENTORY_LINE = '/inventory/line',
  INVENTORY_WAREHOUSE = '/inventory/warehouse',
  INVENTORY_MOVEMENTS = '/inventory/movements',
  
  // Reports routes
  REPORTS = '/reports',
  REPORTS_ENABLEMENT = '/reports/enablement',
  CURRENT_STATUS = '/reports/tnt-current-status',
  REPORTS_INVENTORY = '/reports/inventory',
  REPORTS_INVENTORY_DASHBOARD = '/reports/inventory-dashboard',
  REPORTS_INVENTORY_DETAILS = '/reports/inventory/details',
  REPORTS_INVENTORY_TAG_EPCIS = '/reports/inventory/tag/epcis',
  REPORTS_TRANSFER = '/reports/transfer',
  REPORTS_TRANSFER_DETAILS = '/reports/transfer/details',
  REPORTS_RECEIVE = '/reports/receive',
  REPORTS_RECEIVE_DETAILS = '/reports/receive/details',
  REPORTS_RECEIVE_LINE_ITEMS = '/reports/receive/line-items',
  REPORTS_RECEIVE_TAG_EPCIS = '/reports/receive/tag/epcis',
  REPORTS_TRACK_TRACE = '/reports/trackntrace',
  REPORTS_ASN_DETAILS = '/reports/asn/details',
  REPORTS_HEALTH_DASHBOARD = '/reports/health-dashboard',
  REPORTS_TENANT_LEVEL = '/reports/tenant-level',
  DI_REPORTS = '/reports/di',
  DI_REPORTS_DETAILS = '/reports/di/details'
}
